/**
 * Newsletter API Service
 * 
 * All newsletter-related API endpoints following the API v2.0 specification.
 */

import { get, post, del } from '../../utils/httpClient';
import logger from '../../utils/logger';

/**
 * Subscribe an email to the newsletter
 */
export const subscribeNewsletter = async (email) => {
  try {
    if (!email || !email.trim()) {
      throw new Error('Email is required');
    }

    const response = await post('/newsletter/subscribe', { email: email.trim() });
    return response;
  } catch (error) {
    logger.error('Failed to subscribe to newsletter', error, { email });
    throw error;
  }
};

/**
 * Unsubscribe an email from the newsletter
 */
export const unsubscribeNewsletter = async (email) => {
  try {
    if (!email || !email.trim()) {
      throw new Error('Email is required');
    }

    const response = await post('/newsletter/unsubscribe', { email: email.trim() });
    return response;
  } catch (error) {
    logger.error('Failed to unsubscribe from newsletter', error, { email });
    throw error;
  }
};

/**
 * Get all newsletter subscribers (admin)
 */
export const fetchAllSubscribers = async () => {
  try {
    const response = await get('/newsletter/subscribers');
    return response.data || [];
  } catch (error) {
    logger.error('Failed to fetch newsletter subscribers', error);
    throw error;
  }
};

/**
 * Get active newsletter subscribers (admin)
 */
export const fetchActiveSubscribers = async () => {
  try {
    const response = await get('/newsletter/subscribers/active');
    return response.data || [];
  } catch (error) {
    logger.error('Failed to fetch active newsletter subscribers', error);
    throw error;
  }
};

